// eslint-disable-next-line import/prefer-default-export
export enum BcxDatePickerTimeLevel {
  MONTH = 1,
  YEAR = 2,
  YEARS = 3
}
